import type React from "react";
import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useState,
} from "react";

interface BlockingLoaderContext {
  isBlocking: boolean;
  setIsBlocking: Dispatch<SetStateAction<boolean>>;
}

const blockingLoaderStore = createContext<BlockingLoaderContext>({
  isBlocking: false,
  setIsBlocking: () => null,
});

const { Provider } = blockingLoaderStore;

const BlockingLoaderProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isBlocking, setIsBlocking] = useState(false);
  return <Provider value={{ isBlocking, setIsBlocking }}>{children}</Provider>;
};

export { BlockingLoaderProvider, blockingLoaderStore };
